import { render, staticRenderFns } from "./StylizedTextArea.vue?vue&type=template&id=6dc6148a&scoped=true&"
import script from "./StylizedTextArea.vue?vue&type=script&lang=js&"
export * from "./StylizedTextArea.vue?vue&type=script&lang=js&"
import style0 from "./StylizedTextArea.vue?vue&type=style&index=0&id=6dc6148a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6148a",
  null
  
)

export default component.exports